import { useEffect, useState, type RefObject } from "react";
import { dentalSectionPhaseEvent, installDentalSectionReveal } from "../dentalSectionReveal";

export function useDentalSectionReveal(ref: RefObject<HTMLElement | null>) {
  useEffect(() => {
    if (ref.current) return installDentalSectionReveal(ref.current);
  }, [ref]);
}

export function useDentalSectionReady(ref: RefObject<HTMLElement | null>) {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const target = ref.current;
    const section = target?.closest("section");
    if (!target || !section) return;
    let visible = false;
    const update = () => setReady(visible && section.dataset.revealReady === "true");
    // A tall section may finish fading before its lower figures are on screen.
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.intersectionRatio >= 0.25) visible = true;
      else if (!entry.isIntersecting) visible = false;
      update();
    }, { threshold: [0, 0.25] });
    observer.observe(target);
    update();
    section.addEventListener(dentalSectionPhaseEvent, update);
    return () => {
      observer.disconnect();
      section.removeEventListener(dentalSectionPhaseEvent, update);
    };
  }, [ref]);
  return ready;
}
